import script from "./FollowupCompleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowupCompleteModal.vue?vue&type=script&setup=true&lang=js"

import "./FollowupCompleteModal.vue?vue&type=style&index=0&id=2d49a5d8&lang=scss"

const __exports__ = script;

export default __exports__